import FilmwebLink from 'src/components/filmweblink/FilmwebLink';
import CheckboxSvg from 'src/components/svg/CheckboxSvg';
import { useState } from 'react';
import styles from "./NewsletterSignup.module.css";

//#region [Props]
type NewsletterSignupProps = {
    isStreaming: boolean;
};
//#endregion

//#region [Component]
export default function NewsletterSignup({ isStreaming }: NewsletterSignupProps) {
    const [isChecked, setIsChecked] = useState(false);
    const [isFull, setIsFull] = useState(false);

    return <div className={styles.SNewsletterSignup}>
        <div>
            <form className={styles.SForm} action="https://filmweb.us6.list-manage.com/subscribe/post?u=e0cead56b303960f1671cd15c&id=2ced82373a&f_id=00fbc2e1f0" method="post" name="mc-embedded-subscribe-form" noValidate target="_blank">
                <input className={styles.SEmailInput} type="email" placeholder="Din epostadresse" required name="EMAIL" id="mce-EMAIL" aria-labelledby="newsletterLabel" onChange={() => setIsFull(true)} />
                <div aria-hidden="true" style={{ position: "absolute", left: "-5000px" }}>
                    <input name="b_e0cead56b303960f1671cd15c_2ced82373a" tabIndex={-1} type="text" defaultValue="" />
                </div>
                <div className="mc-field-group input-group" style={{ display: "none" }} aria-hidden="true">
                    <input type="checkbox" value="8" name="group[8][8]" id="mce-group[8]-8-0" checked={!isStreaming} readOnly />
                    <input type="checkbox" value="16" name="group[8][16]" id="mce-group[8]-8-1" checked={isStreaming} readOnly />
                </div>
                <button className={styles.SSubmitButton} id="mc-embedded-subscribe" name="subscribe" type="submit" disabled={!isChecked}>Send</button>
            </form>
        </div>

        <div className={styles.SPersonvern} onClick={() => setIsChecked(!isChecked)}>
            <CheckboxSvg className={styles.SCheckboxSvg} isChecked={isChecked} />
            <div className={styles.SLabel}>Godta <FilmwebLink className={styles.SPersonvernLink} to="https://forms.filmweb.no/form/displayform?id=20" rel="noopener noreferrer" target="_blank">personvernerklæringen</FilmwebLink></div>
        </div>
        {!isChecked && isFull && <div className={styles.SError}>Du må godta personvernerklæringen</div>}
    </div>;
}


const REGULAR_NEWSLETTER_ID = "565147c29b";
const STREAMING_NEWSLETTER_ID = "243fb0d50f";
//#endregion
